import { TopBar } from "./TopBar";

interface AppLayoutProps {
  children: React.ReactNode;
  title?: string;
  icon?: React.ElementType;
}

export function PageContent({ children }: { children: React.ReactNode }) {
  return (
    <main id="soc-main" className="flex-1 min-h-0 relative overflow-hidden bg-background">
      <div className="absolute inset-0 overflow-auto px-3 py-3 sm:px-6 sm:py-4">
        <div className="w-full mx-auto">{children}</div>
      </div>
    </main>
  );
}

export function AppLayout({ children, title, icon }: AppLayoutProps) {
  return (
    <div className="flex flex-col h-screen w-full overflow-hidden bg-background text-primary">
      <TopBar title={title} icon={icon} />
      <div className="flex flex-col flex-1 min-h-0 overflow-hidden">{children}</div>
      <footer className="shrink-0 border-t border-border bg-background">
        <div className="flex items-center justify-between px-6 h-10 mx-auto w-full">
          <span className="text-[13px] text-muted">
            &copy; {new Date().getFullYear()} Nagravision SA &mdash; All rights reserved
          </span>
          <span className="text-[13px] text-muted hidden sm:block">SOC &middot; v1.0</span>
        </div>
      </footer>
    </div>
  );
}
